<template>
  <el-select v-model="productId"
             @change="handleChange"
             filterable
             remote
             clearable
             :multiple="multiple"
             placeholder="请输入商品名称/备注"
             :remote-method="remoteMethod"
             :loading="loading">
    <el-option v-for="item in options"
               :key="item.productId"
               :label="item.productNameFull"
               :value="item.productId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'ent-product-auto-select',
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      // type: [Number, null],
      required: true
    },
    callback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  watch: {},
  computed: {
    productId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    remoteMethod (query) {
      if (query) {
        this.loading = true
        this.$store.dispatch('product/getproducts', {
          payload: {
            pageNum: 1,
            pageSize: 10000,
            productName: query,
            vendorId: null
          },
          success: (res) => {
            this.loading = false
            this.options = res.data.records.map(i => {
              return {
                ...i,
                productNameFull: i.productName + (i.productNameRemark ? `【${i.productNameRemark}】` : '')
              }
            })
          },
          fail: () => {
            this.loading = false
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
